module.exports = __webpack_public_path__ + "static/media/BG_34.53617dad.png";